import React from 'react';
import UploadProgressBar from 'components/VideoAnalysis/UploadProgressBar';

type UploadSuccessProps = {
  uploadProgress: number | null;
};

function UploadSuccess({ uploadProgress }: UploadSuccessProps) {
  return (
    <>
      <div className="flex flex-col items-start gap-8">
        <h6 className="typography-product-heading-compact text-color-text-brand dark:text-color-text-brand">
          Your video is being uploaded
        </h6>
        <p>Please don’t exit the screen until the video is finished uploading.</p>
      </div>
      <div className="my-16 flex flex-col items-center">
        {uploadProgress !== null && <UploadProgressBar progress={uploadProgress} />}
      </div>
    </>
  );
}

export default UploadSuccess;
